"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "rotateAtom", {
    enumerable: true,
    get: function() {
        return rotateAtom;
    }
});
const _reactmotion = require("@fluentui/react-motion");
const createRotateValue = (axis, angle)=>{
    return `${axis.toLowerCase()} ${angle}deg`;
};
const rotateAtom = ({ direction, duration, easing = _reactmotion.motionTokens.curveLinear, delay = 0, axis = 'y', angle = -90, exitAngle = -angle })=>{
    let fromAngle = angle;
    let toAngle = 0;
    if (direction === 'exit') {
        fromAngle = 0;
        toAngle = exitAngle;
    }
    const keyframes = [
        {
            rotate: createRotateValue(axis, fromAngle)
        },
        {
            rotate: createRotateValue(axis, toAngle)
        }
    ];
    return {
        keyframes,
        duration,
        easing,
        delay
    };
};
